module.exports = __webpack_public_path__ + "img/solflare.8672b855.svg";